import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
//import { GlobalserviceService } from '../globalservice.service';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { GlobalserviceService } from '../../globalservice.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
  signinuser;
  user;
  data; datareason;
  type;
  [x: string]: any;
  constructor(private router: Router, public snackBar: MatSnackBar, public globalservice: GlobalserviceService, ) { }

  ngOnInit() {
    this.user = {};
    this.data = {};
  }

  passwordFormControl = new FormControl('', [
    Validators.required
  ]);
  userFormControl = new FormControl('', [
    Validators.required
  ]);
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }


  login(mydata) {
    if (mydata.userid == '1000' && mydata.password == 'admin') {
      this.Type = 's'
    } else {
      this.Type = 'a'
    }
    var signinuser = {
      "Admin_Emp_Id": mydata.userid,
      "Password": mydata.password,
      "Type": this.Type
    };
    sessionStorage.setItem("siginType", this.Type);
    this.globalservice.signin(signinuser).subscribe(responsedata => {
      this.globalservice.disableloader();
      if (responsedata.Success) {
        this.router.navigate(['/dashboard/OD_User']);
        this.register = responsedata['Data'];
        this.firstloc = responsedata['Data'][0]['LOCATION'];
        sessionStorage.setItem("signinlocation", this.firstloc);
        if (sessionStorage.siginType == 'a') {
          this.router.navigate(['/dashboard/mainpanel_SubAdmin']);
          this.register = responsedata['Data'];
          this.latitude = responsedata['latitude'];
          this.longitude = responsedata['longitude'];
          sessionStorage.setItem("signinlocation", this.firstloc);
          sessionStorage.setItem("LatLogin", this.latitude);
          sessionStorage.setItem("LongLogin", this.longitude);
        
        }
      }

      else {
        this.snackBar.open('Incorrect Credentials', '', { duration: 3000 });
      }
    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }

  forgetpwd(mydata) {
    if (mydata.userid == undefined) {
      this.snackBar.open('Please enter  Employee ID', '', { duration: 3000 });
    }
    var forgot = {
      "Admin_EMP_ID": mydata.userid,

    };
    this.globalservice.Forgetpwd(forgot).subscribe(responsedata => {
      this.globalservice.disableloader();
      if (responsedata.Success) {
        this.datareason = responsedata['Message']
        this.snackBar.open(this.datareason, '', { duration: 3000 });

      }
      else {
        this.datareason = responsedata['Message']
        this.snackBar.open(this.datareason, '', { duration: 3000 });
      }
    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }
}
